import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';

export const HTTPIntegrationURLListItem = z.object({
  url: z.string(),
  filename: z.string(),
});

export type HTTPIntegrationURLListItem = z.infer<
  typeof HTTPIntegrationURLListItem
>;

export const HTTPIntegrationCustomHeaderListItem = z.object({
  key: z.string(),
  value: z.string(),
});

export type HTTPIntegrationCustomHeaderListItem = z.infer<
  typeof HTTPIntegrationCustomHeaderListItem
>;

export const HTTPIntegrationCustomHeadersWithSecrets = z.object({
  headerName: z.string(),
  headerSecretReference: SecretReference.optional(),
});

export type HTTPIntegrationCustomHeadersWithSecrets = z.infer<
  typeof HTTPIntegrationCustomHeadersWithSecrets
>;

export const HTTPIntegration = BaseIntegration.extend({
  integrationType: z.literal('HTTP'),
  urlList: z.array(HTTPIntegrationURLListItem), // list of URLs and filenames for downloading
  timeoutInSeconds: z.number(), // timeout, in seconds
  retryCount: z.number(), // number of retries
  customHeaderList: z.array(HTTPIntegrationCustomHeaderListItem), // custom headers
  customHeadersWithSecrets: HTTPIntegrationCustomHeadersWithSecrets, // custom headers with secrets for values (current only one)
});

export type HTTPIntegration = z.infer<typeof HTTPIntegration>;
